module.exports = __webpack_public_path__ + "img/list.a26be8d1.png";